import { createSlice } from "@reduxjs/toolkit";
import { postStaffDetail } from "../../api/staff";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addStaffSlice = createSlice({
  name: "addStaff",
  initialState: data,
  reducers: {
   addStaffSlice(state) {
      state.isLoading = true;
    },
   addStaffSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addStaffSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addStaffSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const addStaffHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addStaffAction.addStaffSlice());
    const response: any = await postStaffDetail(data);
    
    dispatch(addStaffAction.addStaffSliceSuccess(response));
  } catch (e: any) {
    dispatch(addStaffAction.addStaffSliceFailure(e?.response?.data));
  }
};

export default addStaffSlice.reducer;
export const addStaffAction = addStaffSlice.actions;